import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { config } from 'src/app/config';
import Util from 'src/app/_helpers/util';
import { LightGallery } from 'lightgallery/lightgallery';
import { Popupmodal } from 'src/app/_helpers/popupmodal';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from '../../modal/modal.component';
import CheckErrortype from 'src/app/_helpers/check-errortype';
import { TranslateService } from '@ngx-translate/core';
import { RfqVendorService } from 'src/app/_services/rfqvendor.services';
import { formatNumber } from '@angular/common';
import { PopupmessagingComponent } from '../../popupmessaging/popupmessaging.component';

@Component({
  selector: 'app-template-rfq',
  templateUrl: './template-rfq.component.html',
  styleUrls: ['./template-rfq.component.scss']
})
export class TemplateRfqComponent implements OnInit {

  @Input() title?: string='';
  @Input() pov?: string='';
  @Input() poId?: string='';
  @Input() rfq?: any;
  @Input() quotation?: any;
  @Input() products?: any;
  @Input() offers?: any
  @Input() isDraft?: string='';
  @Input() procurementState?: string='';
  @Input() rfqIdParticipate?:string='';
  
  arrMoreLessDesc: any=[];
  arrMoreLessDescOffer:any=[]
  arrDescOffer:any=[];

  currentUrl:string="";
  valshareData:any
  QuotationState:string="";
  totalQuotationPrice: number = 0;
  btnLoading:boolean=false;
  
  private lightGallery!: LightGallery;
  private needRefresh = false;
  
  
  constructor(
        private modalService: NgbModal,
        private popupmodal : Popupmodal,
        private rfqvendorservice: RfqVendorService,
        private translate: TranslateService
  ) { }

  ngOnInit(): void {


    this.QuotationState = this.quotation?.state

    if(this.products instanceof Array){
      this.products.forEach((e:any,i:any) => {
         this.arrMoreLessDesc.push('less')
         this.arrMoreLessDescOffer.push('less')
      });
    }

    if(this.offers instanceof Array){
       var totals = 0
       this.offers.forEach((obj: any, key: any) => {
        // var offerDesc = this.divDetailspec(this.offers[key]['productDescOffered'])
        var offerDesc = null
        if(this.pov=='procurement'){
          offerDesc = this.divDetailspec(this.offers[key]['offeredProductDescription'])
        } else {
          offerDesc = this.divDetailspec(this.offers[key]['productDescOffered'])
        }

        var idItm = this.offers[key]['rfqItemId']
        this.arrDescOffer[idItm]=offerDesc

        totals = totals + (obj.priceOffered * obj.qtyOffered)
       })
       this.totalQuotationPrice = totals
    }
    console.log("arrMoreLessDescOffer :: ",this.arrMoreLessDescOffer)
    console.log("arrDescOffer :: ",this.arrDescOffer)

    this.currentUrl = window.location.href;
    console.log("app-temlate-rfq : this.rfq ",this.rfq)
    

    // fix issue on share rfq board. rfq board dont have rfqId
    // var prepareData:any = {'id':this.rfq?.rfqId,'rfqDisplayId':this.rfq?.rfqDisplayId}
    var prepareData:any 
    if(this.rfq?.rfqId){
      prepareData = {'id':this.rfq?.rfqId,'rfqDisplayId':this.rfq?.rfqDisplayId}
    } else {
      prepareData = {'id':this.rfq?.id,'rfqDisplayId':this.rfq?.rfqDisplayId}
    }



     console.log("app-temlate-rfq : this.rfq prepareData ",prepareData)
    this.valshareData = prepareData

    console.log('quotation : ',this.quotation)

  }


  divDetailspec(val:any){
    return Util.formatShortDesc(val) 
  }

  textDetailspecLess(val:any,type:string){
    var checkChar = Util.formatShortDesc(val)
    var maxChar:number = type=='mobile'?30:50;
    if(checkChar){
      if(checkChar.length>30){
        checkChar = checkChar.substring(0,maxChar) + '...'
      }
    } else {
      return ''
    }
    return checkChar
  }

  divDetailspecLess(val:any){
    //return Util.formatShortDesc(val)
    var checkChar = Util.formatShortDesc(val)

    if(checkChar?.length>50){
      checkChar = checkChar.substring(0,50) + '...'
    }
    return checkChar

  }  

  MoreLessDesc(i:any,action:string){
    this.arrMoreLessDesc[i]=action; 
  }  

  MoreLessDescOffer(i:any,action:string){
    this.arrMoreLessDescOffer[i]=action; 
  }


  divspec(val:any){
    return Util.fhspectocomma(val)
  }

  formatDisplayId(displayId: any) {
    var re = new RegExp('.{1,4}', 'g');
	  return displayId.match(re).join("-");
  }
  
  mappingProductWithOffer(idproduct:any,param:any){
    var newObj:any=null
    if(this.offers  instanceof Array){
    this.offers.forEach((obj: any, key: any) => {
      if (obj.rfqItemId == idproduct) {
        
        if(param=='productDescOffered'){
          newObj = this.divDetailspec(this.offers[key][param])
        }else if(param=='productDescOfferedSpec'){

          if(this.pov=='procurement'){
            newObj = this.divspec(this.offers[key]['offeredProductDescription'])
          } else {
            newObj = this.divspec(this.offers[key]['productDescOffered'])
          }


        }else{
          newObj = this.offers[key][param]
        }

      }
    });
    }
    if(!newObj){
      return '-'
    } else {
      return newObj
    }
   
  }

  compareProductPrice(idproduct:any,param:any){
    var newObj=0
    if(this.offers instanceof Array){
    this.offers.forEach((obj: any, key: any) => {
      if (obj.rfqItemId == idproduct) {
        newObj = this.offers[key][param]
        if(this.offers[key][param]){
          newObj = this.offers[key][param] - this.offers[key]['priceOffered']
        }
      }
    });
    }
    if(newObj>0){
      return true
    } else {
      return false
    }
  }

  mappingProductWithmarketIntelligent(idproduct:any,param:any){
    var newObj:any=null
    this.offers.forEach((obj: any, key: any) => {
      if (obj.rfqItemId == idproduct) {



        if(this.offers[key]['marketIntelligent']){
          newObj = this.offers[key]['marketIntelligent'][param]
        }
        
      }
    });
    return newObj
  }

  ConfirmsubmitMarketLeader(quotationItemId:any,quotationRfqId:any){

    const modalRef = this.modalService.open(ModalComponent, {
      modalDialogClass: 'modal-dialog-centered div-modal-content',
      centered: true,
      size: 'md'
    })
    modalRef.componentInstance.modalconfirm = 'modal'
    modalRef.componentInstance.title = 'Confirm Market Intelligent'
    modalRef.componentInstance.subtitle = 'Are you sure want to run Market Intelligent for this product ?'
    modalRef.componentInstance.yesStr = 'Confirm'
    modalRef.componentInstance.noStr = 'Cancel'

    modalRef.componentInstance.confirmedClick.subscribe((res: any) => {
      if (res) this.submitMarketLeader(quotationItemId,quotationRfqId)
    })


  }
  submitMarketLeader(quotationItemId:any,quotationRfqId:any){
    var quotationId = this.quotation?.id

    console.log('quotationId : ',quotationId);
    console.log('quotationItemId : ',quotationItemId);
    console.log('quotationRfqId : ',quotationRfqId);

    this.btnLoading = true
    this.rfqvendorservice
    .getSubmitMarketLead(quotationId,quotationItemId,quotationRfqId)
    .subscribe((res:any) => {
      
      const modalRef = this.modalService.open(ModalComponent, {
        modalDialogClass: 'modal-dialog-centered div-modal-content',
        centered: true,
        backdrop : 'static',
        keyboard : false,
        size: 'sm'
      })

      if(res.data){
        console.log("succes, get data:", res);

        modalRef.componentInstance.modalinfo = 'info'
        modalRef.componentInstance.infoTitle = 'Success!' // 'Opps Something Wrong!' 
        modalRef.componentInstance.infoSuccess = 'Market Intelligent submitted'
        modalRef.componentInstance.infoFailed = null
        modalRef.componentInstance.closeTxt = 'Close'

        modalRef.componentInstance.confirmedClick.subscribe((res: any) => {
          if (res){
            window.location.reload();
            //this.back()
          } 
        })

      }
      else if(res.errors){
        this.btnLoading = false
        var error = res.errors[0].message
        //this.loading=false
        console.log('error',error);
        var errMsg = error + '';
        var result = errMsg.split(":");
        var resMsg = result[result.length - 1];
        var msg = (resMsg)? resMsg: errMsg
        console.log('msg',msg);
        //alert(msg)

        var errortext = msg

        console.log('res',res.errors[0].extensions.type);
        if(res.errors[0].extensions.type){
          //get translate error, if exsit, replace errortext
          this.translate.get('error.'+res.errors[0].extensions.type).subscribe((data:any)=> {
            if (this.translate.instant('error.'+res.errors[0].extensions.type) !== 'error.'+res.errors[0].extensions.type){
              errortext = data
            }
          });
          //force redirect on specific errortype
          var forceRedirect = CheckErrortype.getResponse(res.errors[0].extensions.type)
          if(forceRedirect){
            window.location.href = forceRedirect
            return
          }
        }
        this.popupmodal.showError(errortext,null).subscribe((res:any) => {})
      }
      else {
        this.popupmodal.showFail().subscribe((res:any) => {})
      } 
    });

  }

  transformDecimal(num:any) {
    return formatNumber(Number(num), 'en-US', '1.0-0')
  }

  sendMessage(){
    console.log('>>quotationId : ',  this.quotation?.id)
    console.log('this.rfq. : ',this.rfq)
    const modalRef = this.modalService.open(PopupmessagingComponent, {
      modalDialogClass: '',
      centered: true,
      backdrop : 'static',
      keyboard : false,
      size: 'md'
    })

    var getRfqId = this.rfq.id ? this.rfq.id :this.rfq.rfqId


    if(this.pov=="vendor"){
      modalRef.componentInstance.title = 'Ask Procurement'
      modalRef.componentInstance.sendMessageAs = 'VENDOR'
      modalRef.componentInstance.rfqid = getRfqId
    }
    if(this.pov=="procurement"){
      modalRef.componentInstance.title = 'Ask Vendor'
      modalRef.componentInstance.sendMessageAs = 'PROCUREMENT'
      modalRef.componentInstance.rfqid = getRfqId
    }


    if(this.quotation?.id){
      // modalRef.componentInstance.rfqid = this.rfq.id
      modalRef.componentInstance.quotationId = this.quotation.id
    } else {
      // modalRef.componentInstance.rfqid = this.rfq.id
      modalRef.componentInstance.quotationId = null
    }
  }  

  settingsGallery = {
    counter: true,
    download:false,
  };
  itemsGallery:any = []

  onInitGallery = (detail:any): void => {
    this.lightGallery = detail.instance;
  };

  ngAfterViewChecked(): void {
    if (this.needRefresh) {
      if(this.itemsGallery.length>0){
        this.lightGallery.refresh();
        this.needRefresh = false;
      }

    }
  }

}
